import { Navigate, useNavigate, useSearchParams } from 'react-router';
import { SignInScreen, readInvitation, safeReturnTo, useSession } from '@platform/app-kit';
import { AUTH_FRAME } from '../shell/brand.ts';

/** `/login` — platform staff sign in against the control-plane pool; TOTP is required by the pool. */
export function LoginPage() {
  const { status } = useSession();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const returnTo = safeReturnTo(params.get('returnTo'), '/tenants');
  if (status === 'authenticated') return <Navigate to={returnTo} replace />;
  return (
    <SignInScreen
      frame={AUTH_FRAME}
      arrival={readInvitation({ search: window.location.search, hash: '' })}
      forgotPasswordHref="/forgot-password"
      onSignedIn={() => void navigate(returnTo, { replace: true })}
    />
  );
}
